window.__upSellModalOpen = false;

if (!customElements.get('product-upsell-modal')) {
  customElements.define('product-upsell-modal', class ProductUpsellModal extends ModalDialog {
    constructor() {
      super();
      this.messageTimeout = null;
    }

    hide() {
      window.__upSellModalOpen = false;
      super.hide();
      this.dispatchEvent(new Event('modalClosed'));
    }

    show(opener) {
      // Only show modal if UPSELL_ENABLED exists
      if (!window.UPSELL_ENABLED) {
        return;
      }

      window.__upSellModalOpen = true;
      super.show(opener);
    }

    showUpsell(rule) {
      // Only show modal if UPSELL_ENABLED exists
      if (!window.UPSELL_ENABLED) {
        return;
      }

      if (!rule) return;

      const productsContainer = this.querySelector('.discount-modal-products');
      productsContainer.innerHTML = '';

      const hiddenContainer = document.querySelector(`.upsell-products-container[data-collection-handle="${rule.getCollectionHandle}"]`);
      if (hiddenContainer) {
        hiddenContainer.childNodes.forEach(node => {
          const clone = node.cloneNode(true);
          productsContainer.appendChild(clone);
        });
      } else {
        productsContainer.innerHTML = `<p>Check the collection <a href="/collections/${rule.getCollectionHandle}">${rule.getCollectionHandle}</a> for discounted products.</p>`;
      }

      const discountSpan = this.querySelector('.upsell-discount');
      if (discountSpan) discountSpan.textContent = `${rule.discountPercent}%`;

      super.show();

      // Attach submit listeners for all product forms inside upsell
      productsContainer.querySelectorAll('product-form').forEach((pf) => {
        pf.dataset.isUpsellForm = true;
        pf.addEventListener('submit', async (evt) => {
          evt.preventDefault();

          const formData = new FormData(pf.form);
          const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

          if (cart) {
            const sectionsToRender = cart.getSectionsToRender().map(s => s.id);
            formData.append('sections', sectionsToRender);
            formData.append('sections_url', window.location.pathname);
          }

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          config.body = formData;

          try {
            const res = await fetch(`${routes.cart_add_url}`, config);
            const response = await res.json();
            if (!response.status) {
              const productTitle = pf.form.querySelector('[name="id"]').dataset.productTitle || 'Product';
              this.showAddedMessage(productTitle);
            }
          } catch (err) {
            console.error('Error adding upsell product:', err);
          }
        });
      });
    }

    showAddedMessage(productTitle) {
      const existingMessage = this.querySelector('.upsell-added-message');
      if (existingMessage) existingMessage.remove();
      if (this.messageTimeout) clearTimeout(this.messageTimeout);

      const messageEl = document.createElement('div');
      messageEl.className = 'upsell-added-message';
      messageEl.textContent = `"${productTitle}" added to basket!`;

      const container = this.querySelector('.product-modal__content-info') || this;
      container.appendChild(messageEl);

      this.messageTimeout = setTimeout(() => {
        messageEl.remove();
      }, 2500);
    }

  });
}
